/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../../../app/modules/auth'
import { Languages } from './Languages'
import { SVG, toAbsoluteUrl } from '../../../helpers'

const HeaderUserMenu: FC = () => {
  const { currentUser, logout } = useAuth()

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={toAbsoluteUrl('/media/avatars/blank.png')} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>{currentUser?.name}</div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {currentUser?.email}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item '>
        <Link to={'/crafted/account/settings'} className='menu-link px-5'>
          <SVG path='/media/icons/duotune/general/gen0071.svg' className='svg-icon-3 me-2' />

          <span className='menu-text'>Mon profil</span>
        </Link>
      </div>
      {currentUser?.roleId === 1 && (
        <>
          <div className='separator my-2'></div>
          {/* <div className='menu-item'>
        <Link to='/settings/company' className='menu-link px-5'>
          <SVG path='/media/icons/duotune/general/gen002.svg' className='svg-icon-3 me-2' />
          <span className='menu-text'>Entreprise</span>
        </Link>
      </div> */}
          {/* <div className='menu-item'>
        <Link to='/settings/vat' className='menu-link px-5'>
          <SVG path='/media/icons/duotune/finance/fin001.svg' className='svg-icon-3 me-2' />
          TVA
        </Link>
      </div> */}

          <div className='menu-item'>
            <Link to='/settings/user' className='menu-link px-5'>
              <SVG path='/media/icons/duotune/general/gen049.svg' className='svg-icon-3 me-2' />
              Utilisateur
            </Link>
          </div>
          <div className='menu-item'>
            <Link to='/settings/preferences' className='menu-link px-5'>
              <SVG path='/media/icons/duotune/general/gen0072.svg' className='svg-icon-3 me-2' />
              Paramétrage de Société
            </Link>
          </div>
        </>
      )}
      {/* <div className='menu-item'>
        <Link to='/settings/bank-account' className='menu-link px-5'>
          <SVG path='/media/icons/duotune/finance/fin002.svg' className='svg-icon-3 me-2' />
          Comptes banquaires
        </Link>
      </div> */}

      {/* <div
        className='menu-item px-5'
        data-menu-trigger='hover'
        data-menu-placement='left-start'
        data-menu-flip='bottom'
      >
        <a href='#' className='menu-link px-5'>
          <span className='menu-title'>My Subscription</span>
          <span className='menu-arrow'></span>
        </a>

        <div className='menu-sub menu-sub-dropdown w-175px py-4'>
          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Referrals
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Billing
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Payments
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link d-flex flex-stack px-5'>
              Statements
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='View your statements'
              ></i>
            </a>
          </div>

          <div className='separator my-2'></div>

          <div className='menu-item px-3'>
            <div className='menu-content px-3'>
              <label className='form-check form-switch form-check-custom form-check-solid'>
                <input
                  className='form-check-input w-30px h-20px'
                  type='checkbox'
                  value='1'
                  defaultChecked={true}
                  name='notifications'
                />
                <span className='form-check-label text-muted fs-7'>Notifications</span>
              </label>
            </div>
          </div>
        </div>
      </div> */}

      {/* <Languages /> */}

      {/* <div className='menu-item px-5 my-1'>
        <Link to='/crafted/account/settings' className='menu-link px-5'>
          Parametre du compte
        </Link>
      </div> */}

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          Déconnexion
        </a>
      </div>
    </div>
  )
}

export { HeaderUserMenu }
